import { Box } from "@chakra-ui/react";
import { colors, Starring } from "goi_common";
import { useRecoilState } from "recoil";
import { reviewStarsState } from "@/atoms/funeralReviewState";

function ReviewStarringSection({ name }: { name: string }) {
  const [star, setStar] = useRecoilState(reviewStarsState);
  return (
    <>
      <Box className="subtitle1_sb" mb="16px">
        {name}에 대한
        <br />
        별점을 남겨주세요
      </Box>
      <Box
        height="100%"
        background={colors.warmGray50}
        borderRadius="5px"
        display="flex"
        alignItems="center"
        padding="32px 64px"
        justifyContent="center"
      >
        <Starring setStar={setStar} star={star} size="35px" gap="7.5px" />
      </Box>
    </>
  );
}
export default ReviewStarringSection;
